// Konto löschen: Bestätigungswort wie bei GitHub. Zwilling: lib/account-delete.js (test/account-delete-rule.test.mjs).
/** Name, sonst E-Mail, sonst ID. */
export const deleteWord = (user) => (user.name && user.name.trim()) || user.email || String(user.id);
/** Eingabe stimmt (Groß/Klein und Ränder egal). */
export const deleteConfirmed = (input, user) => String(input || '').trim().toLowerCase() === deleteWord(user).trim().toLowerCase();
